import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["className"],
  _excluded2 = ["overflow", "overflowX", "className"],
  _excluded3 = ["placement"],
  _excluded4 = ["isNumeric"],
  _excluded5 = ["isNumeric"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ../../../react-shim.js
import React from "react";

// src/table.tsx
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";

// ../../utilities/shared-utils/src/index.ts
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(" ");
};

// src/table.tsx
import { createContext } from "@chakra-ui/react-context";
var _createContext = createContext({
    name: "TableStylesContext",
    errorMessage: "useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Table />\" "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  TableStylesProvider = _createContext2[0],
  useTableStyles = _createContext2[1];
var Table = forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig("Table", props);
  var _omitThemingProps = omitThemingProps(props),
    className = _omitThemingProps.className,
    tableProps = _objectWithoutProperties(_omitThemingProps, _excluded);
  return /* @__PURE__ */React.createElement(TableStylesProvider, {
    value: styles
  }, /* @__PURE__ */React.createElement(chakra.table, _objectSpread({
    ref: ref,
    __css: styles.table,
    className: cx("chakra-table", className)
  }, tableProps)));
});
Table.displayName = "Table";

// src/table-container.tsx
import { chakra as chakra2, forwardRef as forwardRef2 } from "@chakra-ui/system";
var TableContainer = forwardRef2(function (props, ref) {
  var _ref;
  var overflow = props.overflow,
    overflowX = props.overflowX,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded2);
  return /* @__PURE__ */React.createElement(chakra2.div, _objectSpread(_objectSpread({
    ref: ref,
    className: cx("chakra-table__container", className)
  }, rest), {}, {
    __css: {
      display: "block",
      whiteSpace: "nowrap",
      WebkitOverflowScrolling: "touch",
      overflowX: (_ref = overflow !== null && overflow !== void 0 ? overflow : overflowX) !== null && _ref !== void 0 ? _ref : "auto",
      overflowY: "hidden",
      maxWidth: "100%"
    }
  }));
});

// src/table-caption.tsx
import { chakra as chakra3, forwardRef as forwardRef3 } from "@chakra-ui/system";
var TableCaption = forwardRef3(function (props, ref) {
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? "bottom" : _props$placement,
    rest = _objectWithoutProperties(props, _excluded3);
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra3.caption, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    __css: _objectSpread(_objectSpread({}, styles.caption), {}, {
      captionSide: placement
    })
  }));
});
TableCaption.displayName = "TableCaption";

// src/thead.tsx
import { chakra as chakra4, forwardRef as forwardRef4 } from "@chakra-ui/system";
var Thead = forwardRef4(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra4.thead, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.thead
  }));
});

// src/tbody.tsx
import { chakra as chakra5, forwardRef as forwardRef5 } from "@chakra-ui/system";
var Tbody = forwardRef5(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra5.tbody, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.tbody
  }));
});

// src/tfooter.tsx
import { chakra as chakra6, forwardRef as forwardRef6 } from "@chakra-ui/system";
var Tfoot = forwardRef6(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra6.tfoot, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.tfoot
  }));
});

// src/th.tsx
import { chakra as chakra7, forwardRef as forwardRef7 } from "@chakra-ui/system";
var Th = forwardRef7(function (_ref2, ref) {
  var isNumeric = _ref2.isNumeric,
    rest = _objectWithoutProperties(_ref2, _excluded4);
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra7.th, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    __css: styles.th,
    "data-is-numeric": isNumeric
  }));
});

// src/tr.tsx
import { chakra as chakra8, forwardRef as forwardRef8 } from "@chakra-ui/system";
var Tr = forwardRef8(function (props, ref) {
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra8.tr, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    __css: styles.tr
  }));
});

// src/td.tsx
import { chakra as chakra9, forwardRef as forwardRef9 } from "@chakra-ui/system";
var Td = forwardRef9(function (_ref3, ref) {
  var isNumeric = _ref3.isNumeric,
    rest = _objectWithoutProperties(_ref3, _excluded5);
  var styles = useTableStyles();
  return /* @__PURE__ */React.createElement(chakra9.td, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    __css: styles.td,
    "data-is-numeric": isNumeric
  }));
});
export { Table, TableCaption, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr, useTableStyles };